import React from "react";
import './header.css'
import logo from '../images/shadow.png'
import {Link} from "react-router-dom";
const LogoContainer = () => {
    return (
        <>
            <div className="logo-header collapse navbar-collapse ">
            <Link to="/"><img src={logo}/></Link>
            </div>
        </>
    )
};
export default LogoContainer;